export enum SidePanelStatus {
  ACTIVE = 'active',
}

export enum SidePanelTab {
  DESCRIPTION = 'description',
  DATA_VISUALISATION = 'data_visualisation',
  TRACKLIST = 'tracklist',
}
